import React from "react";
import { ArrowUpRight, Check } from "lucide-react";
import { pricing } from "../mock";

const Pricing = () => {
  return (
    <section id="pricing" className="icg-section">
      <div className="icg-container">
        <div className="max-w-3xl">
          <span className="icg-eyebrow"><span className="icg-dot" /> Pricing breakdown</span>
          <h2 className="font-display font-semibold tracking-tight mt-5"
              style={{ fontSize: "clamp(36px, 5vw, 64px)", lineHeight: 1.02 }}>
            Fair, transparent
            <br />
            <span className="font-serif-it text-[color:var(--icg-accent)]">from day one</span>.
          </h2>
          <p className="mt-6 text-[color:var(--icg-muted)] leading-relaxed">
            Special discounts for partner companies, non-profits, and in select cases partner
            projects. All pricing is based on an honest hourly rate, our real overhead, and the
            long-term cost of properly communicating with and supporting our clientele.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {pricing.map((p) => (
            <div
              key={p.id}
              className={`icg-lift rounded-3xl p-8 flex flex-col ${
                p.highlighted
                  ? "bg-[color:var(--icg-ink)] text-[color:var(--icg-cream)]"
                  : "bg-[color:var(--icg-cream-soft)] text-[color:var(--icg-ink)]"
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="font-display text-sm opacity-70">{p.id}</span>
                {p.highlighted && (
                  <span className="text-xs px-2.5 py-1 rounded-full bg-[color:var(--icg-accent)] text-[color:var(--icg-ink)] font-medium">
                    Most popular
                  </span>
                )}
              </div>
              <h3 className="mt-6 font-display font-semibold text-3xl tracking-tight">
                {p.name}
              </h3>
              <p className={`mt-1 text-sm ${p.highlighted ? "opacity-70" : "text-[color:var(--icg-muted)]"}`}>
                {p.tagline}
              </p>
              <div className="mt-6 font-display text-2xl font-medium">{p.price}</div>

              <ul className="mt-6 space-y-3 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm">
                    <span
                      className={`mt-0.5 h-5 w-5 rounded-full flex items-center justify-center shrink-0 ${
                        p.highlighted ? "bg-[color:var(--icg-accent)] text-[color:var(--icg-ink)]" : "bg-[color:var(--icg-ink)] text-[color:var(--icg-cream)]"
                      }`}
                    >
                      <Check size={12} />
                    </span>
                    <span className={p.highlighted ? "opacity-90" : ""}>{f}</span>
                  </li>
                ))}
              </ul>

              <a
                href="#contact"
                className={`mt-8 icg-btn ${
                  p.highlighted
                    ? "bg-[color:var(--icg-accent)] text-[color:var(--icg-ink)] hover:brightness-95"
                    : "icg-btn--dark"
                }`}
              >
                Get a quote <ArrowUpRight size={16} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
